import { render, staticRenderFns } from "./sentIpfcByEmail.vue?vue&type=template&id=0ba957a4"
import script from "./sentIpfcByEmail.vue?vue&type=script&lang=js"
export * from "./sentIpfcByEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports